export default __webpack_public_path__ + "static/media/negocio.684d4822.png";